module.exports = __webpack_public_path__ + "static/media/dbms.62e36911.jpg";